import { useMediaQuery } from '@mui/material';
import React from 'react';

import { UsersPageDataRow } from 'api/users/types';
import { MediaBreakpoints } from 'hooks/Screen/useScreenSize';

interface UserPageTableExpandableProps {
  data: UsersPageDataRow;
}

const UserPageTableExpandable: React.FC<UserPageTableExpandableProps> = ({ data }) => {
  const tablet = useMediaQuery(MediaBreakpoints.tablet);
  const desktop = useMediaQuery(MediaBreakpoints.desktop);

  return (
    <div className="d-flex w-100 flex-column">
      {tablet && (
        <div className="d-flex flex-column my-2 mx-3">
          <div>
            <span className="me-1 fs-14 fw-bold">Email</span>
          </div>
          <div>{data?.email}</div>
        </div>
      )}

      {desktop && (
        <>
          <div className="d-flex flex-column my-2 mx-3">
            <div>
              <span className="me-1 fs-14 fw-bold">Role</span>
            </div>
            <div>{data?.role}</div>
          </div>
          <div className="d-flex flex-column my-2 mx-3">
            <div>
              <span className="me-1 fs-14 fw-bold">Phone</span>
            </div>
            <div>{data?.phone_number}</div>
          </div>
        </>
      )}
    </div>
  );
};

export default UserPageTableExpandable;
